import React from "react"
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";
import EditBankPage from "../../../../../entities/DashboardPage/AccountingModule/BankPage/EditBankPage";

function EditBank() {
  const {state} = useLocation();
  const {item} = state||{};
  const navigate = useNavigate();
  const {showAlert} = useAlert();

  const handleEdit = async (data,mobile,cCode) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleEditBank(data,item?._id,mobile,cCode);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);

        showAlert(result?.message,"success")
        navigate("/dashboard/bankHome")
        // console.slog(result?.success,"new employe data ---")
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message,"error")
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error,"success")
      // Handle error
      //   alertErrorMessage(error);
    }
  };

  return (
    <EditBankPage handleEdit ={handleEdit} item={item}/>
  )
}

export default EditBank;